import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { I as Icon } from '../Icon/Icon-C7C24ly7.js';
import { s as spinner } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-B_pWoZ1u-Bxh9jPb6.js';

const LoadingIcon = ({
  ...rest
}) => /*#__PURE__*/React__default.createElement(Icon, _extends({
  type: spinner
}, rest));

export { LoadingIcon as L };
//# sourceMappingURL=LoadingIcon-CQzblct_.js.map
